/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react';

import { asField } from 'informed';

import MuiDatePickerField from './MuiDatePickerField';
import TextField from './TextField';

const supportsDateInput = () => {
  const input = document.createElement(`input`);
  input.setAttribute(`type`, `date`);

  const notADateValue = `not-a-date`;
  input.setAttribute(`value`, notADateValue);

  return !(input.value === notADateValue);
};

class DatePickerGenericFieldComponent extends Component {
  constructor(props) {
    super(props);
    this.props = props;

    this.state = {
      hasDateInput: supportsDateInput(),
    };
  }

  render() {
    const { hasDateInput } = this.state;
    return hasDateInput ? <TextField {...this.props} /> : <MuiDatePickerField {...this.props} />;
  }
}

DatePickerGenericFieldComponent.propTypes = {};

export default asField(DatePickerGenericFieldComponent);
